import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class OtherDeposit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      otherDepositDetails: this.props.otherDepositDetails,
      otherDepositApplicable: this.props.otherDepositApplicable,
    };
  }

  render() {
    return (
      <div className="tabHolder mb-4">
        <div className="row tabForm">
          <Accordion defaultActiveKey="0">
            {this.state.otherDepositApplicable == "yes" ? (
              Object.keys(this.state.otherDepositDetails).map(function (
                key,
                index1
              ) {
                return this.state.otherDepositDetails[key].map(function (
                  rent,
                  index
                ) {
                  console.log(this.state.otherDepositDetails[key]);
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index1}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {rent.period}
                              {` `}
                              {`( Period Term - ${
                                rent.periodTermYY == ""
                                  ? "0"
                                  : rent.periodTermYY
                              }Y -${
                                rent.periodTermMM == ""
                                  ? "0"
                                  : rent.periodTermMM
                              }M -${
                                rent.periodTermDD == ""
                                  ? "0"
                                  : rent.periodTermDD
                              }D )`}
                              {` -`}
                              {` `}
                              {rent.depositNature}
                              {` - `}
                              {rent.otherDepositName}
                              {` `}
                              {` - `}
                              {`From ${leaseDateFormat(rent.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(rent.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rent.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rent.periodTermYY == ""
                                            ? "0"
                                            : rent.periodTermYY}
                                          {"-"}
                                          {rent.periodTermMM == ""
                                            ? "0"
                                            : rent.periodTermMM}
                                          {"-"}
                                          {rent.periodTermDD == ""
                                            ? "0"
                                            : rent.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Deposit Nature (ODEP){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rent.depositNature} (
                                          {rent.otherDepositName})
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rent.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(rent.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Deposit Rate UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rent.rateUOM}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          ODEP # Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {rent.rate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {rent.otherDepositName !==
                                    "Storage Deposit" &&
                                    rent.otherDepositName !==
                                      "Fitout Deposit" && (
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              ODEP On Units{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {rent.onUnits}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  {rent.otherDepositName ===
                                    "Storage Deposit" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            No.of Months
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rent.monthsCount}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {rent.rateUOM === "Per Sq.ft" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Area
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rent.area}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {rent.otherDepositName ===
                                    "Fitout Deposit" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {rent.onArea}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          ODEP Total Amount{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {Math.round(rent.amount)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          ODEP MileStones
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple tableSimpleWithNoFlex">
                                              <thead>
                                                <tr>
                                                  <th scope="col">
                                                    Milestone Name
                                                  </th>
                                                  <th scope="col">Due Date</th>
                                                  <th scope="col">
                                                    ODEP Percent
                                                  </th>
                                                  <th scope="col">
                                                    RDEP Milestone Amount (Rs.)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {rent.milestones.length > 0 &&
                                                  rent.milestones.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>
                                                          {name.milestoneName}
                                                        </td>
                                                        <td>
                                                          {leaseDateFormat(
                                                            name.dueDate
                                                          )}
                                                        </td>
                                                        <td>
                                                          {Math.round(
                                                            name.milestonePercent
                                                          )}
                                                          {" %"}
                                                        </td>
                                                        <td>
                                                          {Math.round(
                                                            name.amount
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                },
                this);
              },
              this)
            ) : (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <h6 className="text-center" style={{ padding: "15px" }}>
                      Other Deposit Not Applicable
                    </h6>
                  </div>
                </div>
              </div>
            )}
          </Accordion>
          {this.state.otherDepositApplicable == "yes" && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Notes
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {this.props.odNotes}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withRouter(OtherDeposit);
